import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">My Art Framing</p>
        <h1>Transform Your Memories into Art</h1>
        <p className="lede">
          Discover our custom framing services designed to showcase your art, photos, and memorabilia beautifully. 
          Elevate your space with personalized frames that reflect your style.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_self">
            Shop Now
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Custom Designs</h2>
          <p>
            Choose from a variety of styles and materials to create the perfect frame for your cherished pieces.
          </p>
        </article>
        <article>
          <h2>Quality Craftsmanship</h2>
          <p>
            Our expert artisans ensure that every frame is crafted with precision and care, using high-quality materials.
          </p>
        </article>
        <article>
          <h2>Fast & Reliable Shipping</h2>
          <p>
            Enjoy quick turnaround times and reliable shipping, so you can start displaying your framed art in no time.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;